import logo from "../images/logo.webp";
import styles from "../styles/Menu.module.css";
import { FaBars, FaTimes, FaRegClock } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Menu() {
  const [openMenu, setOpenMenu] = useState(false);
  const [servicesExpanded, setServicesExpanded] = useState(false);

  const toggleMenu = () => setOpenMenu(!openMenu);
  const toggleServices = () => setServicesExpanded(!servicesExpanded);

  // Close dropdowns when mobile menu closes
  const closeMenu = () => {
    setOpenMenu(false);
    setServicesExpanded(false);
  };

  return (
    <div className={styles.barsContainer}>
      <div className={styles.topStrip}>
        <div>
          <p className={styles.emergency247}>
            24/7 Emergency Garage Door Repair – Calgary & Area
          </p>
          <p className={styles.sameDay}>
            <FaRegClock size={25} />
            Same-Day Service
          </p>
        </div>
      </div>

      <nav className={styles.Menubar}>
        <div className={styles.navHeader}>
          <div className={styles.logoContainer}>
            <Link to="/">
              <img
                src={logo}
                alt="Profixer Door Services logo"
                className={styles.logo}
              />
            </Link>
          </div>

          <button
            className={styles.hamburger}
            onClick={toggleMenu}
            aria-controls="main-menu"
          >
            {openMenu ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <ul
          className={`${styles.menu} ${openMenu ? styles.showMenu : ""}`}
          id="main-menu"
          role="menubar"
          aria-label="Main navigation"
        >
          <li>
            <HashLink to="/#top" onClick={() => setOpenMenu(false)}>
              Home
            </HashLink>
          </li>

          {/* SERVICES WITH DROPDOWN */}
          <li className={styles.hasDropdown} role="none">
            <button
              className={styles.dropdownToggle}
              onClick={toggleServices}
              aria-expanded={servicesExpanded}
              aria-haspopup="true"
              aria-controls="services-menu"
            >
              Services <span className={styles.arrow} aria-hidden="true">▾</span>
            </button>

            <div
              className={`${styles.dropDownContainer} ${servicesExpanded ? styles.show : ''}`}
              id="services-menu"
              role="menu"
              aria-label="Services submenu"
            >
              <ul className={styles.dropDown} role="none">
                <li role="none">
                  <HashLink
                    smooth
                    to="/spring-repair"
                    onClick={closeMenu}
                    role="menuitem"
                  >
                    Spring Repair
                  </HashLink>
                </li>
                <li role="none">
                  <HashLink
                    smooth
                    to="/cable-track"
                    onClick={closeMenu}
                    role="menuitem"
                  >
                    Cable & Track Repair
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/roller-hinge"
                    onClick={() => setOpenMenu(false)}
                  >
                    Roller, Hinge & Bracket Repair
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/panel-door"
                    onClick={() => setOpenMenu(false)}
                  >
                    Panel & Door Repair
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/opener-services"
                    onClick={() => setOpenMenu(false)}
                  >
                    Opener Services
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/control-access"
                    onClick={() => setOpenMenu(false)}
                  >
                    Control & Access
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="sensor-electrical"
                    onClick={() => setOpenMenu(false)}
                  >
                    Sensor & Electrical
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/garage-door-installation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Garage Door Installation
                  </HashLink>
                </li>
                <li
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <HashLink
                    smooth
                    to="/emergency-repairs"
                    onClick={() => setOpenMenu(false)}
                  >
                    Emergency & Same-Day Repairs
                  </HashLink>
                </li>
              </ul>
            </div>
          </li>

          {/* OPERATION AREA WITH SAME DROPDOWN */}
          <li className={styles.hasDropdown}>
            <HashLink
              smooth
              to="/#operation"
              onClick={() => setOpenMenu(false)}
            >
              Operation area <span className={styles.arrow}>▾</span>
            </HashLink>

            <div className={styles.dropDownContainer}>
              <ul className={styles.dropDown}>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Calgary (All Quadrants)
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Airdrie
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Cochrane
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Chestermere
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Okotoks
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Strathmore
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    High River
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Bragg Creek
                  </HashLink>
                </li>
                <li>
                  <HashLink
                    smooth
                    to="/#operation"
                    onClick={() => setOpenMenu(false)}
                  >
                    Rocky View County
                  </HashLink>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <HashLink to="/#gallery" onClick={() => setOpenMenu(false)}>
              Gallery
            </HashLink>
          </li>
          <li onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            <Link to="/how-to-choose" onClick={() => setOpenMenu(false)}>
              How to choose a door
            </Link>
          </li>
          <li>
            <HashLink to="/#about" onClick={() => setOpenMenu(false)}>
              About
            </HashLink>
          </li>
        </ul>

        <a
          href="tel:4036907147"
          className={`${styles.btn} ${styles.btnPrimary} ${styles.btnSm}`}
        >
          <IoCall size={18} /> Call Now: (403) 690-7147
        </a>
      </nav>
    </div>
  );
}

export default Menu;
